"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDelaunays = exports.delaunayPoints = void 0;
const d3 = __importStar(require("d3"));
const chart_helpers_1 = require("../../util/chart.helpers");
const delaunayPoints = function (drawParams) {
  let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : d => d;
  let dataSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : chart_helpers_1.uniqueMetricMap;
  const {
    data,
    params
  } = drawParams;
  const filtered = data.filter(filter);
  if (filtered.length === 0) return [];
  const xType = filtered[0].metric ? filtered[0].metric.xType : 'years';
  return (0, chart_helpers_1.allDataPoints)(filtered, params.startDate, params.endDate, xType, dataSelector);
};
exports.delaunayPoints = delaunayPoints;
const getDelaunays = function (drawParams, xScale, yScale, filter) {
  let dataSelector = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : chart_helpers_1.uniqueMetricMap;
  const points = (0, exports.delaunayPoints)(drawParams, filter, dataSelector);
  const scaledPoints = points.map(d => [xScale(d.key), yScale(d.value)]);
  return {
    '2d': d3.Delaunay.from(scaledPoints),
    x: d3.Delaunay.from(scaledPoints.map(_ref => {
      let [x] = _ref;
      return [x, 0];
    })),
    points
  };
};
exports.getDelaunays = getDelaunays;